// MobileLoginView.jsx
import React, { useState } from 'react';

import { GoogleLogin } from '@react-oauth/google';
import OrLine from '../../components/common/OrLine';
import LogInForm from './LoginPage';
import SignUpForm from './Signuppage';
import MySheet from '../../components/BottomSheet/ForgotPassword';
import { mobileLoginViewtalwind } from './MobileLoginTalwind';


export default function MobileLoginView({
  formGreetings,
  formSubGreetings,
  onVerifyToken,
  runOneSignal,
  formType,
  referral
}) {
    const responseMessage = (response) => {
        console.log(response)
         const values = { token: response.credential };
         onVerifyToken(values);
      };
      const errorMessage = (error) => {
        console.log(error);
      };
      const [sheetOpen, setSheetOpen] = useState(false);
      const BacktoSignin =()=>{
        setSheetOpen(false);
        }
  return (
    <section className={mobileLoginViewtalwind.baseContainer}>
      {/* Top Banner */}
      <div className={mobileLoginViewtalwind.topContainer}>
        <img
          src={require('../../Assets/img/registration/cover.jpg')}
          alt="Login Banner"
          className={mobileLoginViewtalwind.topConImg}
        />
      </div>
      {/* Bottom Card */}
      <div className={mobileLoginViewtalwind.bottomContainer}>
        <div className={mobileLoginViewtalwind.btmHeadCon}>
        <img
                src={require('../../Assets/odds_logo_blue.png')}
                className="h-[52px]"
              />
          <h1 className={mobileLoginViewtalwind.baseHeading}>
            {formGreetings}
          </h1>
          <p className={mobileLoginViewtalwind.secondBaseHead}>
            {formSubGreetings}
          </p>
          <div className='mt-1'>
          <GoogleLogin text='continue_with'
            onSuccess={responseMessage} onError={errorMessage} />
          </div>
        </div>
        <OrLine />
        <div className='w-full'>
        {formType == 'SIGNUP' ? ( <SignUpForm runOneSignal={runOneSignal} />):( <LogInForm runOneSignal={runOneSignal} setFPWDSec={setSheetOpen} referral={referral} />)}
        </div>
        
      </div>
      <MySheet isOpen={sheetOpen} closefun={() => BacktoSignin()} />
    </section>
  );
}
